import { useMessageCenter } from '../../message/useMessageCenter'
import config from '@/config/user.env'
import store from '@/store'

/* @ts-check */

/** @typedef {import('./types.ts').DfContextType} DfContextType */

/**
 * @param {DfContextType} context
 */
export function setupDataFinder(context = window) {
    context.collectEvent('init', {
        // eslint-disable-next-line camelcase
        app_id: config.dataFinderAppId, //  应用的appid，应用列表详情处的appid
        //  saas版本参考，默认为saas版本，其他版本按照需求作修改
        // channel: 'cn', // saas数据发送地址，私有化可忽略
        // SaaS云原生版本参考
        // channel_domain: 'https:// gator.volces.com', //  设置数据上送地址
        // eslint-disable-next-line camelcase
        channel_domain: 'https://iotsdk.midea.com', // 设置私有化部署数据上送地址，参考2.2节获取
        // ab_channel_domain: 'https:// tab.volces.com', //  分流请求域名
        // 私部版本参考
        // channel_domain: 'https:// xxxx.com', // 私有部署配置私applog地址域名/数据上报地址域名，saas可忽略
        // ab_channel_domain: 'https:// xxx.com', // 如果使用私有部署AB产品，需要配置私applog地址域名/数据上报地址域名，saas可忽略
        autotrack: false, // 是否开启全埋点上报
        log: config.env !== 'PROD', //  开启调试日志，上线请关闭
    })
    context.collectEvent('start')

    const mc = useMessageCenter()
    mc.observe('/auth/setup-user-identity', 'info').by(message => {
        const userId = `${store.getters.identityInfo.mobile}-${store.getters.identityInfo.customerCode}`
        // console.log('IN DataFinder setup: logined', message, userId, store.state.user.user.userName)

        // @ts-ignore
        context.collectEvent('config', {
            // eslint-disable-next-line camelcase
            user_unique_id: userId, // 用户唯一ID
        })
    })

    mc.observe('/event-tracking', 'info').by((eventName, payload) => {
        // console.log('observed /datafinder', eventName, payload)

        if (eventName === 'upload-file-size') {
            context.collectEvent('debug__upload_size', {
                ...payload,
                L3: '货主端',
            })
        }
    })
}
